import React from "react";

const AboutUs = () => {
	return (
		<section className="flex items-center justify-center lg:px-24 p-10 lg:py-16 bg-white">
			<div className="flex justify-between items-start w-full">
				{/* Images Section */}
				<div className="lg:block hidden relative w-1/2 h-[550px]">
					<img
						src="./images/aboutUsTL.png"
						alt="Top Left"
						className="absolute w-80 h-auto rounded-lg"
					/>
					<img
						src="./images/aboutUsBR.png"
						alt="Bottom Right"
						className="absolute w-80 h-auto rounded-lg bottom-0 right-0"
					/>
				</div>

				{/* Content Section */}
				<div className="relative lg:w-1/2 lg:pl-10">
					<h3 className="text-lg m-0">About Us</h3>
					<h1 className="text-3xl font-bold font-serif my-4">
						Sri Seetha Rama Seva Sadan
					</h1>
					<p className="lg:text-base text-sm text-justify leading-7 mb-8 text-gray-500">
						Sri Seetha Rama Seva Sadan was established on 02-04-2003 by Sri
						Gattu Narayana Guruji in memory of his parents, Sri Gattu Ramanna
						and Srimati Muddu Seethamma, in Manthani, which is known as
						Mantrakuta since ancient times to serve and contribute to the
						society and people of Manthani.
					</p>
					<button className="bg-emerald-600 text-white px-6 py-3 text-base font-medium rounded-lg hover:bg-emerald-700 mb-8">
						Read More
					</button>
					{/* Highlights Section */}
					<div className="lg:absolute right-0">
						<h4 className="text-xl font-bold mb-4">Highlights</h4>
						<ul className="list-disc pl-6 text-base">
							<li className="mb-2">Supporting elderly individuals in need</li>
							<li className="mb-2">Environmental sustainability through tree plantations</li>
							<li className="mb-2">Educational scholarships and infrastructure development</li>
							<li className="mb-2">Skill development programs for women and youth</li>
							<li className="mb-2">Medical aid and ambulance services</li>
						</ul>
					</div>
				</div>
			</div>
		</section>
	);
};

export default AboutUs;
